import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import WithError from '../../../../../../components/with-error/WithError';
import { Input } from '../../../../../../components/common-inputs';

function SupportFields() {
  const { t } = useTranslation('contact');

  return (
    <>
      <Field name='supportTopic' autoComplete='supportTopic'>
        {({ meta, input }) => (
          <WithLabel label={t('supportTopic')} variant={LABEL_STYLES.COLUMN} isBold isTwoDots isRequired>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
            </WithError>
          </WithLabel>
        )}
      </Field>
    </>
  );
}

export default SupportFields;
